import { usePageHeader } from "@/components/layouts/lib/page-header";
import { PartiesContent } from "./parties/components/PartiesContent";
import { PartiesPageIntro } from "./parties/components/PartiesPageIntro";
import { PartiesToolbar } from "./parties/components/PartiesToolbar";
import { PartyStatsGrid } from "./parties/components/PartyStatsGrid";
import { PARTIES_PAGE_GUIDE } from "./parties/parties.constants";
import { usePartiesPageData } from "./parties/hooks/usePartiesPageData";
import { usePartiesPageState } from "./parties/hooks/usePartiesPageState";

export default function PartiesPage() {
  usePageHeader({
    title: "Parties",
    helpTopic: "parties",
    guide: {
      steps: PARTIES_PAGE_GUIDE,
    },
  });

  const pageState = usePartiesPageState();
  const pageData = usePartiesPageData(pageState.filters);

  return (
    <div>
      <PartiesPageIntro />
      <PartyStatsGrid stats={pageData.stats} loading={pageData.statsLoading} />
      <PartiesToolbar
        search={pageState.search}
        roleFilter={pageState.roleFilter}
        viewMode={pageState.viewMode}
        total={pageData.total}
        onSearchChange={pageState.setSearch}
        onRoleFilterChange={pageState.setRoleFilter}
        onViewModeChange={pageState.setViewMode}
      />
      <PartiesContent
        isLoading={pageData.isLoading}
        viewMode={pageState.viewMode}
        parties={pageData.parties}
      />
    </div>
  );
}
